import React, { useEffect } from "react";
import { ThemeProvider } from "styled-components";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { useModuleConfig, ModuleType } from "../";

import { GamificationActions } from "./redux/gamification.reducer";
import { Container } from "./gamification.styled";
import { selectDateTo } from "./redux/gamification.selectors";
import { FinishedScreen } from "./components/finishedScreen/finishedScreen.component";
import { NotFoundPage } from "../../app/notFoundPage/notFoundPage.component";
import { CheckAuthLayout } from '../../components';

import { gamificationRoutes } from './gamification.routes';

const Gamification = () => {
  const config = useModuleConfig(ModuleType.Gamification);
  const location = useLocation();
  const navigate = useNavigate();
  const dateTo = useSelector(selectDateTo);
  const gamificationAvailable = dateTo
    ? Date.now() / 1000 - dateTo <= 0
    : dateTo === null;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(GamificationActions.fetchCurrentLevel());
  }, [dispatch]);

  useEffect(() => {
    if (config.urls.includes(location.pathname)) {
      navigate(config.routes.init, { replace: true });
    }
  }, [navigate]);

  if (dateTo === undefined) return <></>;

  if (!gamificationAvailable) return <FinishedScreen />;

  return (
    <ThemeProvider theme={config.theme}>
      <Container>
        <Routes>
          <Route element={<CheckAuthLayout />}>
            {gamificationRoutes.map((route) =>
              Object.values(route.pathSettings.urls).map((url, index) => {
                const Component = route.component;

                return (
                  <Route
                    key={`${url}-${index}`}
                    path={url}
                    element={<Component />}
                  />
                );
              })
            )}
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Container>
    </ThemeProvider>
  );
};

export default Gamification;
